import {
  posthogAnonymousUserCaptureEvent,
  posthogUserCaptureEvent, posthogUserIdentifyAnonymousUserEvent, posthogUserIdentifyPikkoUserEvent,
} from './userEvent';
import { POSTHOG_CAPTURE_USER_ANONYMOUS_PROFIL_CREATED, POSTHOG_CAPTURE_USER_PROFIL_CREATED } from './constants';

const getLocalStorageContext = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const store = JSON.parse(localStorage.getItem('store') || 'null');
    const cart = JSON.parse(localStorage.getItem('cartItems') || 'null');

    const context = {};
    if (user?._id) context.user_id = user._id;
    if (user?.guestId) context.guest_id = user.guestId;
    if (user?.phoneNumber) context.phone_number = user.phoneNumber;
    if (store?.store?.id) context.store_id = store.store.id;
    if (cart?._id) context.order_id = cart._id;
    return context;
  } catch {
    return {};
  }
};

export const getPostHogOptions = (user = null) => {
  return {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    person_profiles: 'always',
    capture_pageview: false,
    capture_pageleave: true,
    capture_dead_clicks: true,
    session_recording: {
      recordNetwork: true,
      recordConsoleLog: true,
      recordCanvas: false,
      recordCrossOriginIframes: false,
      networkPayloadCapture: {
        recordHeaders: true,
        recordBody: true,
        recordPerformance: true,
        bodyMaxSize: 10000,
      },
    },

    opt_in_site_apps: process.env.NODE_ENV === 'production',
    debug: process.env.NODE_ENV === 'development',

    capture_heatmaps: true,
    disable_session_recording: false,

    persistence: 'localStorage+cookie',

    request_batching: true,
    batch_request_timeout_ms: 10000,

    respect_dnt: true,
    opt_out_capturing_by_default: false,

    before_send: (properties) => {
      try {
        return { ...properties, ...getLocalStorageContext() };
      } catch {
        return properties;
      }
    },

    loaded: (posthog) => {
      const currentId = posthog.get_distinct_id();
      console.info('PostHog loaded with distinct_id:', currentId);

      try {
        if (user?._id) {
          if (currentId !== user._id) {
            console.info('Creating alias:', currentId, '->', user._id);
            posthog.alias(currentId, user._id);
          }
          posthogUserIdentifyPikkoUserEvent(user);
          posthogUserCaptureEvent(user, POSTHOG_CAPTURE_USER_PROFIL_CREATED);

        } else {
          posthogUserIdentifyAnonymousUserEvent(currentId);
          posthogAnonymousUserCaptureEvent(currentId, POSTHOG_CAPTURE_USER_ANONYMOUS_PROFIL_CREATED);
        }

      } catch (error) {
        console.error('Error in PostHog loaded callback:', error);
      }
    },
  };
};
